import React, { useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// actions
import { addPackingStandard } from "../../../store/actions"
import { useEffect } from "react"

const AddPackingStandard = props => {
  const dispatch = useDispatch()
  document.title = "Add packing standard"

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      packing_standard: "",
    },
    validationSchema: Yup.object({
      packing_standard: Yup.string().required("Please Enter Packing Standard"),
    }),
    onSubmit: values => {
      dispatch(addPackingStandard(values, props.history))
    },
  })

  const packStands = useSelector(state => state.packingStandard)
  const { error } = useSelector(state => ({
    error: state.packingStandard.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Add Packing Standard" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="formPackingStandard"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="pckStands">
                            Packing Standard
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="packing_standard"
                            className={
                              validation.touched.packing_standard &&
                              validation.errors.packing_standard
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="pckStands"
                            placeholder="Enter Packing Standard"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.packing_standard || ""}
                          />
                          {validation.touched.packing_standard &&
                          validation.errors.packing_standard ? (
                            <FormFeedback type="invalid">
                              {validation.errors.packing_standard}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      {packStands && packStands.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Adding ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Add
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default AddPackingStandard
